export default __webpack_public_path__ + "static/media/balluchon-150.127cab60.png";